import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import {
  type SocietyFileInfoOutput,
  type SocietyFileKeyPostBodyInput,
  type SocietyFileKeyOutput,
} from "shared/api/types/society/[societyId]/files";
import {
  type SocietyFileOrSlugParamsInput,
  type SocietyFileIdParamsInput,
} from "shared/api/types/society/[societyId]/files/[fileIdOrSlug]";
export const getSocietyFileIdOrSlugContract: BaseApiContract<
  SocietyFileOrSlugParamsInput,
  undefined,
  SocietyFileInfoOutput
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/files/[fileIdOrSlug]",
  paramsType: {} as SocietyFileOrSlugParamsInput,
  responseType: {} as SocietyFileInfoOutput,
};
export const deleteSocietyFileIdOrSlugContract: BaseApiContract<
  SocietyFileOrSlugParamsInput,
  undefined,
  any
> = {
  method: HttpMethod.DELETE,
  apiRoute: "/api/v1/society/[societyId]/files/[fileIdOrSlug]",
  paramsType: {} as SocietyFileOrSlugParamsInput,
  responseType: undefined as unknown as any,
};
export const postSocietyFileIdOrSlugContract: BaseApiContract<
  SocietyFileIdParamsInput,
  SocietyFileKeyPostBodyInput,
  SocietyFileKeyOutput
> = {
  method: HttpMethod.POST,
  apiRoute: "/api/v1/society/[societyId]/files/[fileIdOrSlug]",
  paramsType: {} as SocietyFileIdParamsInput,
  bodyType: {} as SocietyFileKeyPostBodyInput,
  responseType: {} as SocietyFileKeyOutput,
};
